import { fromFetch } from 'rxjs/fetch';
import { leadsRecommendedCommunitySubmission, leadsGetRecommendedCommunities } from 'constants/routes';

export const postRecommendedCommunities = (payload) => {
  const requestObject = {
    'credentials': 'include',
    method: 'POST',
    body: JSON.stringify({
      ...payload,
    }),
    headers: {
      'Content-Type': 'application/json',
    },
    selector: (response) => response.text(),
  };

  fetch(leadsRecommendedCommunitySubmission, requestObject);
};

export const getRecommendedCommunities$ = (payload) => {
  const requestObject = {
    'credentials': 'include',
    method: 'POST',
    body: JSON.stringify({
      leadCommand: {
        ...payload,
      },
    }),
    headers: {
      'Content-Type': 'application/json',
    },
    selector: (response) => response.text(),
  };

  return fromFetch(leadsGetRecommendedCommunities, requestObject);
};
